import * as React from 'react'
import { useEffect, useState } from 'react'
import { isMobile, isTablet } from 'react-device-detect'
import { matchPath, useHistory } from 'react-router'
import { NavLink } from 'react-router-dom'

import commonRepo from '@/repository/common.repo'

import S from './NavigationLink.style'

type Props = {
  matchUrl?: string
  onClick?: () => void
} & React.ComponentProps<NavLink>

function NavigationLink({ to, children: label, matchUrl, onClick, ...props }: Props) {
  const history = useHistory()
  const [isPressed, setPressed] = useState<boolean>(false)
  const lastTo = typeof to === 'function' ? to(commonRepo.router.location) : to
  const isTouchableDevice = isMobile || isTablet

  useEffect(() => {
    if (isPressed) {
      history.push(lastTo)
      setPressed(false)
    }
  }, [isPressed])

  const handleClickStart = (e) => {
    e.preventDefault()
    onClick?.()
    setPressed(true)
  }

  return (
    <NavLink
      data-testid={`navigation-${label}`}
      data-component={`${label}탭`}
      to={to}
      css={S.link}
      activeStyle={S.active}
      isActive={(match, location) => {
        const customMatch = matchPath(location.pathname, { path: matchUrl })
        return isPressed || (matchUrl ? !!customMatch : !!match)
      }}
      onTouchStart={isTouchableDevice ? handleClickStart : undefined}
      onMouseDown={!isTouchableDevice ? handleClickStart : undefined}
      {...props}
    >
      {label}
    </NavLink>
  )
}

export default NavigationLink
